import { RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE } from '../RentalPortalArchive.constants'

import RentalPortalIcon from '../../../../icons/rental-portal.svg'
import ViewingIcon from '../../../../icons/viewing.svg'

export const RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE_ICON = {
  [RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE.listing]: RentalPortalIcon,
  [RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE.viewing]: ViewingIcon,
}
